import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

export const appInsights: ApplicationInsights = new ApplicationInsights({
  config: {
    disableAjaxTracking: true,
    instrumentationKey: environment.appInsightsConfig.instrumentationKey,
    enableAutoRouteTracking: false,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    correlationHeaderExcludedDomains: [
      'myapp.azurewebsites.net',
      '*.queue.core.windows.net',
    ],
  },
});
